//import SelectDateController from "../ReuseComps/SelectDateController";
import DateController from "../ReuseComps/DateController";

export default function SelectDateOmega() {


  return (
      
      <DateController
         category = "omega_health"
      />

  );
}
